import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-invitation-step-organizers',
  templateUrl: './step-organizers.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class InvitationStepOrganizersComponent {
  @Input() form!: FormGroup;
  constructor(private fb: FormBuilder) {}
  get organizers(): FormArray { return this.form.get('organizers') as FormArray; }
  addOrganizer(): void {
    this.organizers.push(this.fb.group({
      id: [''], name: [''], email: [''], role: ['presenter'], notify: [false],
    }));
  }
  removeOrganizer(i: number): void { this.organizers.removeAt(i); }
}
